module.exports = __webpack_public_path__ + "media/images/new-32-green-e546875210ba82bc5e87f3b4405e9213.png";